import { useCallback, useEffect, useState } from 'react';
import {
  getHistoryImportPeriods, deleteHistoryImportPeriod,
} from '../../../services/performanceHistoryImportService';

// PM analitik P6 — geçmiş dönem içe aktarma listesi (EmployeesPage aynası: DataTable + GenericFormDrawer + ConfirmDialog).
export const KINDS = ['level', 'score'];
export const ISSUE_PREVIEW_LIMIT = 200;

export function useHistoryImportApi(queryParams) {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [fetching, setFetching] = useState(false);
  const [failed, setFailed] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const key = JSON.stringify(queryParams);

  useEffect(() => {
    let alive = true;
    setFetching(true);
    getHistoryImportPeriods(queryParams).then((res) => {
      if (!alive) return;
      // api.js GET'te reject etmez: hata sinyali res.data.status — "yüklenemedi" ile "boş" ayrı durum.
      if (res?.data?.status) {
        setData(res.data.data?.data || []);
        setTotal(res.data.data?.totalRowCount || 0);
        setFailed(false);
      } else {
        setData([]);
        setTotal(0);
        setFailed(true);
      }
      setFetching(false);
    });
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, refreshKey]);

  const refresh = useCallback(() => setRefreshKey((k) => k + 1), []);

  const remove = useCallback(async (periodId) => {
    try {
      const res = await deleteHistoryImportPeriod(periodId);
      if (res?.data?.status) { refresh(); return true; }
    } catch {
      // hata tostu interceptor'da
    }
    return false;
  }, [refresh]);

  return { data, total, fetching, failed, refresh, remove };
}

/** Önizleme özetinin gösterilecek satırları (sıfır olanlar gizlenir; hata/uyarı her zaman). */
export function summaryItems(preview) {
  if (!preview) return [];
  const items = [
    ['totalRows', preview.totalRows, true],
    ['validRows', preview.validRows, true],
    ['errorRows', preview.errorRows, true],
    ['warningRows', preview.warningRows, true],
    ['matchedByRegistrationNumber', preview.matchedByRegistrationNumber, false],
    ['matchedByEmail', preview.matchedByEmail, false],
    ['formerEmployees', preview.formerEmployees, false],
    ['leftInPeriod', preview.leftInPeriod, false],
    ['withoutFinal', preview.withoutFinal, false],
    ['currentOrgUsed', preview.currentOrgUsed, false],
    ['added', preview.added, false],
    ['updated', preview.updated, false],
    ['removed', preview.removed, false],
    ['unchanged', preview.unchanged, false],
  ];
  return items.filter(([, v, always]) => always || Number(v) > 0).map(([key, value]) => ({ key, value: value ?? 0 }));
}

/** Kayıt ancak önizleme hatasızsa, en az bir geçerli satır varsa ve önizlemeden sonra form değişmediyse yapılabilir. */
export function canCommit(preview, stale) {
  return !!preview && !stale && preview.errorRows === 0 && preview.validRows > 0 && !preview.noChanges;
}

/** Yeni dönem formunun istemci tarafı ön koşulları (asıl doğrulama sunucuda). */
export function metaReady(meta, reupload) {
  if (reupload) return true;
  if (!meta.name || !meta.name.trim() || !meta.startDate || !meta.endDate) return false;
  if (meta.startDate >= meta.endDate) return false;
  if (!KINDS.includes(meta.resultKind)) return false;
  return meta.resultKind === 'score' || !!meta.ratingScaleId;
}
